import { render, staticRenderFns } from "./bottomButton.vue?vue&type=template&id=3d0e9648&scoped=true"
import script from "./bottomButton.vue?vue&type=script&lang=js"
export * from "./bottomButton.vue?vue&type=script&lang=js"
import style0 from "./bottomButton.vue?vue&type=style&index=0&id=3d0e9648&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e9648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0e9648')) {
      api.createRecord('3d0e9648', component.options)
    } else {
      api.reload('3d0e9648', component.options)
    }
    module.hot.accept("./bottomButton.vue?vue&type=template&id=3d0e9648&scoped=true", function () {
      api.rerender('3d0e9648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/bottomButton.vue"
export default component.exports